export const Autogrow = {

	/*
	**  Set the methods
	*/

	methods: {

		autogrowInit: function() {

			$('textarea').autogrow();

		}

	}

}